import { empty } from "@angular-devkit/schematics";

export type ImageName = keyof typeof images;

export const images = {
  landscapeLogin: './assets/images/landscape-login.jpg',
  landscape: './assets/images/landscape.svg',
  login: {
    username: './assets/images/user.svg',
    password: './assets/images/password.svg',
    code: './assets/images/code.svg',
    back: './assets/images/back-to-login.svg',
  },
  darkMode: {
    sun: './assets/images/sun.svg',
    moon: './assets/images/moon.svg',
  },
  notification: {
    alert: './assets/images/alert.svg',
    success: './assets/images/success.svg',
    danger: './assets/images/danger.svg',
    warning: './assets/images/warning.svg',
    close: './assets/images/close.svg',
    error: './assets/images/error.svg',
    userActive: './assets/images/user-active.svg',
    userInactive: './assets/images/user-inactive.svg',
    userBlocked: './assets/images/user-blocked.svg',
    userDeleted: './assets/images/user-deleted.svg',
  },
  notifications: {
    check: './assets/images/notifications/check.svg',
    info: './assets/images/notifications/info.svg',
    warning: './assets/images/notifications/warning.svg',
  },
  sidebar: {
    admin: './assets/images/admin.svg',
    users: './assets/images/sidebar/users.svg',
    operators: './assets/images/sidebar/operators.svg',
    vehicles: './assets/images/sidebar/vehicles.svg',
    towns: './assets/images/sidebar/towns.svg',
    services: './assets/images/sidebar/services.svg',
    trips: './assets/images/sidebar/trips.svg',
    bookings: './assets/images/sidebar/bookings.svg',
    messages: './assets/images/sidebar/messages.svg',
    dashboard: './assets/images/sidebar/dashboard.svg',
    apps: './assets/images/sidebar/apps.svg',
    clients: './assets/images/client.svg',
    identityProvider: './assets/images/sidebar/identity-provider.svg',
  },
  logos: {
    backofficeLogo: './assets/images/backoffice-logo.svg',
    nemiSmall: './assets/images/nemi-small.svg',
    nemiLarge: './assets/images/nemi-large.svg',
    nemiWithoutBackground: './assets/images/nemi-without-background.svg',
  },
  userProfile: {
    languages: './assets/images/languages.svg',
    signOut: './assets/images/sign-out.svg',
    changePassword: './assets/images/password.svg',
  },
  flags: {
    ca: './assets/images/flags/ca.svg',
    el: './assets/images/flags/el.svg',
    en: './assets/images/flags/en.svg',
    es: './assets/images/flags/es.svg',
    it: './assets/images/flags/it.svg',
    pt: './assets/images/flags/pt.svg',
    eu: './assets/images/flags/eu.svg',
    fr: './assets/images/flags/fr.svg',
  },
  user: {
    name: './assets/images/user.svg',
    mail: './assets/images/mail.svg',
    phone: './assets/images/phone.svg',
    id: './assets/images/id.svg',
    calendar: './assets/images/date.svg',
    star: './assets/images/star.svg',
    addUser: './assets/images/add-user.svg',
    addDriver: './assets/images/add-driver.svg',
    userActive: './assets/images/user-active.svg',
    userDisabled: './assets/images/user-disabled.svg',
    userInactive: './assets/images/user-disabled.svg',
    userDeleted: './assets/images/user-deleted.svg',
    userBlocked: './assets/images/user-blocked.svg',
    edit: './assets/images/edit.svg',
    account: './assets/images/account.svg',
    area: './assets/images/area.svg',
    comments: './assets/images/comments.svg',
    gender: './assets/images/gender.svg',
    birthDate: './assets/images/birthdate.svg',
    settlement: './assets/images/town.svg',
    additionalPhone: './assets/images/additional-phone.svg',
    role: './assets/images/rol.svg',
    privacyPolicy: './assets/images/privacy-policy.svg',
    language: './assets/images/language.svg',
    clients: './assets/images/client.svg',
    notifications: './assets/images/notification.svg',
    device: './assets/images/smart-phone.svg',
    token: './assets/images/token.svg',
    smartPhone: './assets/images/smart-phone.svg',
    password: './assets/images/password.svg',
    operator: './assets/images/operator.svg',
    changelog: './assets/images/info.svg',
    boPassword: './assets/images/bo-password.svg',
    usageIntention: './assets/images/usage-intention.svg',
  },
  suggestions: {
    complaint: './assets/images/complaint.svg',
    suggestion: './assets/images/suggestion.svg',
    incidence: './assets/images/complaint.svg',
    observation: './assets/images/observation.svg',
    objectLost: './assets/images/object-lost.svg',
    objectFound: './assets/images/object-found.svg',
    suggestionsIcon: './assets/images/suggestions-icon.svg',
    messagesIcon: './assets/images/messages-icon.svg',
    addSuggestion: './assets/images/add-suggestion.svg',
    info: './assets/images/info.svg',
    affair: './assets/images/config.svg',
    user: './assets/images/user.svg',
    driver: './assets/images/driver.svg',
    town: './assets/images/area.svg',
    date: './assets/images/date.svg',
    edit: './assets/images/edit.svg',
    reply: './assets/images/reply.svg',
    conversation: './assets/images/conversation.svg',
    sendMessage: './assets/images/message-send.svg',
    clients: './assets/images/client.svg',
    internNotes: './assets/images/menu-burger.svg',
    services: './assets/images/sidebar/services.svg',
    sortOptions: {
      creation: './assets/images/date-check.svg',
      lastmodification: './assets/images/date.svg',
      priority: './assets/images/arrow-up.svg',
      status: './assets/images/pending-state.svg',
    },
    priority: {
      low: './assets/images/low-priority.svg',
      medium: './assets/images/medium-priority.svg',
      high: './assets/images/high-priority.svg',
      highest: './assets/images/highest-priority.svg',
    },
    status: {
      rejected: './assets/images/rejected-state.svg',
      inProgress: './assets/images/in-progress-state.svg',
      processed: './assets/images/enabled.svg',
      pending: './assets/images/pending-state.svg',
    },
    visibility: {
      PRIVATE: './assets/images/lock.svg',
      OPERATIONAL: './assets/images/bus.svg',
      INSTITUTIONAL: './assets/images/building.svg',
      PASSENGERS: './assets/images/passengers.svg',
      PUBLIC: './assets/images/world.svg',
    },
    expedition: './assets/images/bus-car.svg',
    activeTickets: './assets/images/alert.svg',
  },
  messages: {
    info: './assets/images/info.svg',
    affair: './assets/images/config.svg',
    clients: './assets/images/client.svg',
    from: './assets/images/arrow-out.svg',
    receiver: './assets/images/arrow-in.svg',
    date: './assets/images/date.svg',
    user: './assets/images/user.svg',
    driver: './assets/images/driver.svg',
    service: './assets/images/service.svg',
    expedition: './assets/images/sidebar/trips.svg',
    route: './assets/images/route.svg',
    description: './assets/images/menu-burger.svg',
    successMessageSent: './assets/images/message-success.svg',
    failedMessageSent: './assets/images/message-error.svg',
    town: './assets/images/area.svg',
    channel: {
      pushNotification: './assets/images/push-notifications.svg',
      email: './assets/images/mail.svg',
      sms: './assets/images/sms.svg',
      multiple: './assets/images/arrows-expand.svg',
    },
    alert: './assets/images/alert.svg',
  },
  booking: {
    user: './assets/images/user.svg',
    service: './assets/images/service.svg',
    date: './assets/images/date.svg',
    stops: './assets/images/stops.svg',
    seats: './assets/images/seats.svg',
    smartPhone: './assets/images/smart-phone.svg',
    notifications: './assets/images/notification.svg',
    searchCriteria: './assets/images/arrow-in.svg',
    pickUpTime: './assets/images/pickup-dropoff-time.svg',
    dropOffTime: './assets/images/pickup-dropoff-time.svg',
    empty: './assets/images/empty.svg',
    feedback: './assets/images/feedback-booking.svg',
    vehicle: './assets/images/vehicle.svg',
    driver: './assets/images/driver.svg',
    addBooking: './assets/images/add-booking.svg',
    area: './assets/images/area.svg',
    eco: './assets/images/eco.svg',
    pedestrian: './assets/images/pedestrian.svg',
    passengers: './assets/images/passengers.svg',
    maxReservationTime: './assets/images/max-reservation-time.svg',
    warning: './assets/images/warning.svg',
    availability: './assets/images/availability.svg',
    noOptions: './assets/images/no-options.svg',
    changeStops: './assets/images/change-stops.svg',
    rebook: './assets/images/rebook.svg',
    recurrent: './assets/images/recurrent.svg',
    repeatBooking: './assets/images/repeat-booking.svg',
    days: './assets/images/date.svg',
    endDate: './assets/images/date-range.svg',
    startDate: './assets/images/date-range.svg',
    fare: './assets/images/fares.svg',
    actions: {
      favorite: './assets/images/star.svg',
      trip: './assets/images/trip.svg',
      user: './assets/images/user.svg',
      open: './assets/images/open.svg',
      edit: './assets/images/edit.svg',
      editCircle: './assets/images/edit2.svg',
      missed: './assets/images/user-deleted.svg',
      delete: './assets/images/delete.svg',
      view: './assets/images/view-booking.svg',
      bulkSelect: './assets/images/bulk-selection.svg'
    },
    notified: {
      app: './assets/images/smart-phone.svg',
      notNotified: './assets/images/not-notified.svg',
      notified: './assets/images/notified.svg',
      phone: './assets/images/phone.svg',
      whatsapp: './assets/images/whatsapp.svg',
    },
    ticket: {
      ticket: './assets/images/ticket.svg',
      ticketOk: './assets/images/ticket.svg',
      ticketWarning: './assets/images/ticket-warning.svg',
      ticketError: './assets/images/ticket-error.svg',
    },
    resend: './assets/images/resend.svg',
  },
  services: {
    route: './assets/images/route.svg',
    addService: './assets/images/add-service.svg',
    gtfs: './assets/images/gtfs.svg',
    import: './assets/images/import.svg',
    export: './assets/images/export.svg',
    edit: './assets/images/edit.svg',
    tag: './assets/images/tag.svg',
    color: './assets/images/color.svg',
    name: './assets/images/name-service.svg',
    client: './assets/images/client.svg',
    criteria: './assets/images/criteria.svg',
    forward: './assets/images/forward.svg',
    backward: './assets/images/backward.svg',
    showTimes: './assets/images/show-times.svg',
    uploadGTFS: './assets/images/upload-gtfs.svg',
    bookingTimePicker: './assets/images/booking-time-picker.svg',
    uploadDocument: './assets/images/upload-document.svg',
    newArea: './assets/images/new-area.svg',
    point: './assets/images/point.svg',
    functionalities: './assets/images/functionalities.svg',
    delete: './assets/images/delete.svg',
    duplicate: './assets/images/duplicate.svg',
    routes: {
      name: './assets/images/name.svg',
      time: './assets/images/time.svg',
      expeditionType: './assets/images/expedition-type.svg',
      addRoute: './assets/images/add-route.svg',
      additionalClients: './assets/images/additional-clients.svg',
      apps: './assets/images/apps.svg',
      area: './assets/images/area.svg',
      client: './assets/images/client.svg',
      config: './assets/images/config.svg',
      downloadGTFS: './assets/images/download-gtfs.svg',
      notifications: './assets/images/notifications.svg',
      publishingSites: './assets/images/publishing-sites.svg',
      settings: './assets/images/settings.svg',
      reorganize: './assets/images/reorganize-routes.svg',
      ticketing: './assets/images/ticketing.svg',
      times: './assets/images/times.svg',
      visibility: './assets/images/visibility.svg',
      criteria: './assets/images/forward.svg',
      distance: './assets/images/distance.svg',
      relateds: './assets/images/relateds.svg',
      sae: './assets/images/sae.svg',
      saeActions: './assets/images/sae-actions.svg',
      visualization: './assets/images/booking-time-picker.svg',
      routeTimes: './assets/images/route-times.svg',
      route: './assets/images/route.svg',
      routeNotification: './assets/images/route-notification.svg',
      delete: './assets/images/delete.svg',
      directionsOrigin: './assets/images/directions.svg',
      fare: './assets/images/fares.svg'
    },
    restrictions: {
      blacklist: './assets/images/block-circle.svg',
      whitelist: './assets/images/check-circle.svg',
      emptyState: './assets/images/empty-state-stops.svg',
      moreOptions: './assets/images/more-options.svg',
      delete: './assets/images/delete.svg',
      restore: './assets/images/back-action.svg',
    }
  },
  availabilities: {
    status: './assets/images/info.svg',
    startDateTime: './assets/images/date.svg',
    endDateTime: './assets/images/date.svg',
    driver: './assets/images/driver.svg',
    vehicle: './assets/images/vehicle.svg',
    trip: './assets/images/sidebar/trips.svg',
    edit: './assets/images/bulk-selection.svg',
    delete: './assets/images/delete.svg',
    event: './assets/images/event.svg',
    backup: './assets/images/duplicate.svg',
  },
  roles: {
    admin: './assets/images/admin.svg',
    driverManager: './assets/images/driver-manager.svg',
    driver_manager: './assets/images/driver-manager.svg',
    operator: './assets/images/operator.svg',
    superadmin: './assets/images/superadmin.svg',
    userDriver: './assets/images/user-driver.svg',
    userRegular: './assets/images/user-regular.svg',
    user: './assets/images/user-regular.svg',
  },
  types: {
    regular: './assets/images/user-regular.svg',
    driver: './assets/images/user-driver.svg',
  },
  sortOptions: {
    alphabetically: './assets/images/alphabetically.svg',
    creation: './assets/images/creation.svg',
  },
  trips: {
    name: './assets/images/name.svg',
    date: './assets/images/date.svg',
    vehicle: './assets/images/vehicle.svg',
    driver: './assets/images/driver.svg',
    open: './assets/images/open.svg',
    ready: './assets/images/ready.svg',
    ongoing: './assets/images/ongoing.svg',
    delete: './assets/images/delete.svg',
    close: './assets/images/complete.svg',
    drivenPosition: './assets/images/driven-position.svg'
  },
  favourites: {
    noOptions: './assets/images/no-favourites.svg',
    calendarFavourite: './assets/images/calendar-favourite.svg',
    recurrent: './assets/images/recurrent.svg',
  },
  setup: {
    viewAvailabilities: './assets/images/availabilities.svg',
    addSetting: './assets/images/add-setting.svg',
    status: './assets/images/status.svg',
    name: './assets/images/settings.svg',
    route: './assets/images/route.svg',
    since: './assets/images/date-range.svg',
    until: './assets/images/date-range.svg',
    calendar: './assets/images/date.svg',
    duration: './assets/images/duration.svg',
    moreOptions: './assets/images/more-options.svg ',
    edit: './assets/images/edit.svg',
    delete: './assets/images/delete.svg',
    duplicate: './assets/images/duplicate.svg',
    enabled: './assets/images/enabled.svg',
    disabled: './assets/images/cancel-circle.svg',
    tag: './assets/images/tag.svg',
    time: './assets/images/time.svg',
    frequency: './assets/images/frequency.svg',
    phoneContact: './assets/images/phone-contact.svg',
    functionalities: './assets/images/functionalities.svg',
    phoneDrivers: './assets/images/smart-phone.svg',
    backgroundTracking: './assets/images/speed.svg',
    dateTime: './assets/images/date-time.svg',
    hour: './assets/images/hour.svg',
    settingsOn: './assets/images/settings-on.svg',
    settingsOff: './assets/images/settings-off.svg',
    addAvailabilities: './assets/images/add-availabilities.svg',
    export: './assets/images/upload-document.svg',
    multicheck: './assets/images/multicheck.svg',
    info: './assets/images/info.svg',
    interval: './assets/images/interval.svg',
    intervalDuration: './assets/images/duration.svg',
    message: './assets/images/message.svg',
    card: {
      time: './assets/images/time.svg',
      driver: './assets/images/driver.svg',
      vehicle: './assets/images/vehicles.svg',
      overlap: './assets/images/overlap.svg',
    },
    emptyState: './assets/images/setup-empty-state.svg',
  },
  routes: {
    design: './assets/images/design-route.svg',
    save: './assets/images/save.svg',
    createSegment: {
      auto: './assets/images/create-segment-auto.svg',
      manual: './assets/images/create-segment-manual.svg',
    },
    delete: './assets/images/delete.svg',
    stop: './assets/images/stop.svg',
    hoverStop: './assets/images/hover-stop.svg',
    selectedStop: './assets/images/origin.svg',
    segment: './assets/images/segment.svg',
    activeSegment: './assets/images/segment-active.svg',
    import: './assets/images/upload-document.svg',
    config: './assets/images/config-route.svg',
    alternative: './assets/images/alternative.svg',
    outline: './assets/images/outline.svg',
    outlineSelected: './assets/images/outline-selected.svg',
    back: './assets/images/back-action.svg',
    forward: './assets/images/forward-action.svg',
    times: './assets/images/open.svg',
    emptyStatePreview: './assets/images/calendar-check.svg',
    notify: './assets/images/notify.svg',
    refund: './assets/images/refund.svg',
    warningRoundFilled: './assets/images/warning-round-filled.svg',
    stops: {
      merge: './assets/images/stop-merge.svg',
      mergeDisabled: './assets/images/stop-merge-disabled.svg',
      mergeSelected: './assets/images/stop-merge-selected.svg',
      start: './assets/images/stop-start.svg',
      startDisabled: './assets/images/stop-start-disabled.svg',
      startSelected: './assets/images/stop-start-selected.svg',
      end: './assets/images/stop-end.svg',
      endDisabled: './assets/images/stop-end-disabled.svg',
      endSelected: './assets/images/stop-end-selected.svg',
      inflexion: './assets/images/stop-inflexion.svg',
      inflexionDisabled: './assets/images/stop-inflexion-disabled.svg',
      inflexionSelected: './assets/images/stop-inflexion-selected.svg',
      demandDefault: './assets/images/stop-demand-default.svg',
      demand: './assets/images/stop-demand.svg',
      demandDisabled: './assets/images/stop-demand-disabled.svg',
      demandSelected: './assets/images/stop-demand-selected.svg',
      alternatives: './assets/images/stop-alternatives.svg',
      alternativesDisabled: './assets/images/stop-alternatives-disabled.svg',
      alternativesSelected: './assets/images/stop-alternatives-selected.svg',
    }
  },
  alterations: {
    active: './assets/images/enabled.svg',
    inactive: './assets/images/cancel-circle.svg',
    calendar: './assets/images/date-range.svg',
    duplicate: './assets/images/duplicate.svg',
    alteration: './assets/images/alternative.svg',
    emptyState: './assets/images/alterations-empty-state.svg',
    edit: './assets/images/edit.svg',
    warningRoundFilled: './assets/images/warning-round-filled.svg',
  },
  vehicles: {
    settings: './assets/images/settings.svg',
    configSchedule: './assets/images/config-schedule.svg',
    busCar: './assets/images/bus-car.svg',
    operator: './assets/images/operator.svg',
    standardSeat: './assets/images/standard-seat.svg',
    prmSeat: './assets/images/prm.svg',
    convertibleSeats: './assets/images/convertible-seat.svg',
    edit: './assets/images/edit.svg',
    position: './assets/images/position.svg',
    collapseRow: './assets/images/unfold-less.svg',
  },
  arrow: './assets/images/arrow.svg',
  arrowDown: './assets/images/arrow-down.svg',
  arrowLeft: './assets/images/arrow-left.svg',
  arrowRight: './assets/images/arrow-right.svg',
  arrowUp: './assets/images/arrow-up.svg',
  download: './assets/images/download.svg',
  downloadList: './assets/images/download-list.svg',
  pencil: './assets/images/pencil.svg',
  driver: './assets/images/driver.svg',
  vehicle: './assets/images/vehicle.svg',
  menuBurger: './assets/images/menu-burger.svg',
  search: './assets/images/search.svg',
  zoomIn: './assets/images/zoom-in.svg',
  zoomOut: './assets/images/zoom-out.svg',
  filter: './assets/images/filter.svg',
  sort: './assets/images/sort.svg',
  visibilityOff: './assets/images/visibility-off.svg',
  visibility: './assets/images/visibility.svg',
  close: './assets/images/close.svg',
  error: './assets/images/error.svg',
  origin: './assets/images/origin.svg',
  destination: './assets/images/destination.svg',
  pax: './assets/images/user-regular.svg',
  minor: './assets/images/minor.svg',
  pet: './assets/images/pet.svg',
  pregnant: './assets/images/pregnant.svg',
  dependant: './assets/images/dependant.svg',
  blind: './assets/images/blind.svg',
  deaf: './assets/images/deaf.svg',
  luggage: './assets/images/luggage.svg',
  package: './assets/images/package.svg',
  bike: './assets/images/bike.svg',
  scooter: './assets/images/scooter.svg',
  prm: './assets/images/prm.svg',
  userAttr: './assets/images/user-attr.svg',
  moreInfo: './assets/images/more-info.svg',
  area: './assets/images/area.svg',
  bus: './assets/images/bus.svg',
  route: './assets/images/route.svg',
  busCar: './assets/images/bus-car.svg',
  busPrivate: './assets/images/bus-private.svg',
  peepotired: './assets/images/peepotired.svg',
  distance: './assets/images/distance.svg',
  distanceBooking: './assets/images/distance_booking.svg',
  speed: './assets/images/speed.svg',
  clock: './assets/images/clock.svg',
  openInFull: './assets/images/open-in-full.svg',
  closeInFull: './assets/images/close-in-full.svg',
  expandInFull: './assets/images/expand-in-full.svg',
  play: './assets/images/play.svg',
  pause: './assets/images/pause.svg',
  create: './assets/images/create.svg',
  plus: './assets/images/plus.svg',
  minus: './assets/images/minus.svg',
  plusFilled: './assets/images/plus-filled.svg',
  minusFilled: './assets/images/minus-filled.svg',
  changeover: './assets/images/changeover.svg',
  confirm: './assets/images/confirm.svg',
  info: './assets/images/info.svg',
  world: './assets/images/world.svg',
  complaint: './assets/images/comment.svg',
  link: './assets/images/link.svg',
  document: './assets/images/document.svg',
  noDocuments: './assets/images/no-documents.svg',
  loading: './assets/animations/loading.svg',
  back: './assets/images/back.svg',
  next: './assets/images/next.svg',
  moreOptions: './assets/images/more-options.svg',
  alert: './assets/images/alert.svg',
  phone: './assets/images/phone.svg',
  usr: './assets/images/user.svg',
  multicheck: './assets/images/multicheck.svg',
  check: './assets/images/check.svg',
  checkCircle: './assets/images/check-circle.svg',
  cancelCircle: './assets/images/cancel-circle.svg',
  done: './assets/images/done.svg',
  stop: './assets/images/stop.svg',
  stopDisabled: './assets/images/stop-disabled.svg',
  viewDetail: './assets/images/functionalities.svg',
  trash: './assets/images/trash.svg',
  comment: './assets/images/info-comment.svg',
  externalLink: './assets/images/external-link.svg',
  firstPage: './assets/images/first-page.svg',
  lastPage: './assets/images/last-page.svg',
  redo: './assets/images/redo.svg',
  cursor: {
    default: './assets/images/cursor-default.svg',
    drag: './assets/images/cursor-drag.svg',
    hover: './assets/images/cursor-hover.svg',
    creationSegmentsAuto: './assets/images/cursor-create-segment-auto.svg',
    creationSegmentsManual: './assets/images/cursor-create-segment-manual.svg',
    outline: './assets/images/cursor-create-outline.svg',
    alternative: './assets/images/cursor-alternative.svg',
    merge: './assets/images/cursor-merge.svg',
  }
};

export const arrows = [
  { name: 'down', img: images.arrowDown },
  { name: 'left', img: images.arrowLeft },
  { name: 'right', img: images.arrowRight },
  { name: 'up', img: images.arrowUp },
];

export const userProfile = [
  { name: 'languages', img: images.userProfile.languages },
  { name: 'signOut', img: images.userProfile.signOut },
  { name: 'changePassword', img: images.userProfile.changePassword },
  { name: 'notifications', img: images.user.notifications },
];

export const flags = [
  { name: 'ca', img: images.flags.ca },
  { name: 'el', img: images.flags.el },
  { name: 'en', img: images.flags.en },
  { name: 'es', img: images.flags.es },
  { name: 'it', img: images.flags.it },
  { name: 'pt', img: images.flags.pt },
  { name: 'eu', img: images.flags.eu },
  { name: 'fr', img: images.flags.fr },
];
